import React from 'react';

export default function Navbar() {
  return (
    <header className="nav">
      <a href="#hero" className="nav__logo">
        Old Monk<em>Tech</em>
      </a>
      <nav className="nav__links">
        <a href="#hero">Home</a>
        <a href="#products">Products</a>
        <a href="#services">Services</a>
        <a href="#testimonials">Testimonials</a>
        <a href="#contact" className="nav__cta">Get in Touch</a>
      </nav>
    </header>
  );
}
